import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedRelative } from 'react-intl';

export default function StatusIndicator({ isOnline, lastSeenTime }) {
    if (isOnline) {
        return (
            <span className="status-indicator" data-online>
                <FormattedMessage id="last_seen_lowercase" />
            </span>
        );
    } else if (lastSeenTime) {
        return (
            <span className="status-indicator" data-offline>
                <FormattedMessage id="last_seen" />
                &nbsp;
                <FormattedRelative style="numeric" value={lastSeenTime} />
            </span>
        );
    }
    return null;
}

StatusIndicator.propTypes = {
    isOnline: PropTypes.bool.isRequired,
    lastSeenTime: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/StatusIndicator.jsx